import { Component, Inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { CommonModule } from '@angular/common';
import { GlobalSearchTabResponsiveComponent } from './global-search-tab-responsive/global-search-tab-responsive.component';
import { NameSearchTabResponsiveComponent } from './name-search-tab-responsive/name-search-tab-responsive.component';
import { KeywordSearchTabResponsiveComponent } from './keyword-search-tab-responsive/keyword-search-tab-responsive.component';
import { DpBottomSheetCloserComponent } from "../../common-component/dp-bottom-sheet-closer/dp-bottom-sheet-closer.component";
import { NamesToUpdateService } from '../../services/raintree/Transmission/names-to-update.service';

@Component({
  selector: 'app-master-search-bottom-sheet',
  standalone: true,
  imports: [CommonModule, GlobalSearchTabResponsiveComponent, NameSearchTabResponsiveComponent, KeywordSearchTabResponsiveComponent, DpBottomSheetCloserComponent],
  templateUrl: './master-search-bottom-sheet.component.html',
  styleUrl: './master-search-bottom-sheet.component.scss'
})
export class MasterSearchBottomSheetComponent {
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private bottomSheetRef: MatBottomSheetRef<MasterSearchBottomSheetComponent>,
    private _namesToUpdateService: NamesToUpdateService,
  ) { }
  activeTab: string = 'globalSearch';
  closesheet():void{
    this.bottomSheetRef.dismiss();
  }

  onClickSerialNo(event: any) {
    console.log('CLICKED...')
    let bodyObj = {
     dpwMemKey: event
    }
     this._namesToUpdateService.updateSerialNo(this.data.memberId,bodyObj).subscribe({
       next: (response: any) => {
         this.bottomSheetRef.dismiss(event);
       },
       error: (error) => {
         console.log(error);
       },
     });
 
   }
}
